import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Shared building blocks for the legal pages, so that the impressum, the
 * privacy policy and the cookie policy share one rhythm and one heading scale.
 */

export const LegalBlock: React.FC<{ children: React.ReactNode; last?: boolean }> = ({
  children,
  last = false,
}) => <Box sx={{ mb: last ? 0 : { xs: 5, md: 7 } }}>{children}</Box>;

export const LegalHeading: React.FC<{ children: React.ReactNode; id?: string }> = ({ children, id }) => (
  <Typography id={id} variant="h4" component="h2" sx={{ mb: 2, color: 'primary.dark' }}>
    {children}
  </Typography>
);

/** A bulleted list of plain strings. */
export const LegalList: React.FC<{ items: readonly string[] }> = ({ items }) => (
  <Box component="ul" sx={{ pl: 3, m: 0, mb: 2, display: 'grid', gap: 1 }}>
    {items.map((item) => (
      <Typography component="li" key={item} variant="body1" sx={{ color: 'text.secondary' }}>
        {item}
      </Typography>
    ))}
  </Box>
);

/** Emphasised one-liner used for legal bases and retention periods. */
export const LegalNote: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic', mt: 1.5 }}>
    {children}
  </Typography>
);
